import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import AdminLayout from './AdminLayout';
import AdminLogs from './pages/AdminLogs';
import AdminDashboard from './pages/AdminDashboard';
import AdminUsers from './pages/AdminUsers';
import AdminSupport from './pages/AdminSupport';
import AdminTicketDetail from './pages/AdminTicketDetail';
import AdminWorkspaces from './pages/AdminWorkspaces';
import AdminMarketplaces from './pages/AdminMarketplaces';
import AdminPromoCodes from './pages/AdminPromoCodes';
import AdminMarketplaceAccounts from './pages/AdminMarketplaceAccounts';
import AdminAgencyRequests from './pages/AdminAgencyRequests';
import AdminSettings from './pages/AdminSettings';
import AdminNotifications from './pages/AdminNotifications';
import AdminBilling from './pages/AdminBilling';
import AdminReferrals from './pages/AdminReferrals';
import AdminJobs from './pages/AdminJobs';
import AdminSchedules from './pages/AdminSchedules';
import AdminPublicProfiles from './pages/AdminPublicProfiles';
import AdminApiTokens from './pages/AdminApiTokens';
import AdminOwnershipTransfers from './pages/AdminOwnershipTransfers';
import AdminAiAgentLogs from './pages/AdminAiAgentLogs';
import AdminAiChatShares from './pages/AdminAiChatShares';
import AdminAiSatisfaction from './pages/AdminAiSatisfaction';
import AdminBlogList from './pages/AdminBlogList';
import AdminBlogEditor from './pages/AdminBlogEditor';
import AdminNewsAutomation from './pages/AdminNewsAutomation';
import AdminMarketingLinks from './pages/AdminMarketingLinks';
import AdminMarketingSources from './pages/AdminMarketingSources';
import AdminMarketingIntegrations from './pages/AdminMarketingIntegrations';
import AdminContentAgent from './pages/AdminContentAgent';
import AdminPlanDefinitions from './pages/AdminPlanDefinitions';
import AdminToolRegistry from './pages/AdminToolRegistry';
import AdminToolManual from './pages/AdminToolManual';
import AdminNotificationCatalog from './pages/AdminNotificationCatalog';
import AdminSystemHealth from './pages/AdminSystemHealth';
import AdminOps from './pages/AdminOps';
import AdminParserHub from './pages/AdminParserHub';
import AdminJev from './pages/AdminJev';
import { useAuth } from '../../hooks/useAuth';

function PermissionRoute({ children, permission }) {
    const { user } = useAuth();
    if (!user) return <Navigate to="/login" replace />;

    const perms = user.admin_permissions || [];
    const hasPermission = perms.includes('all') || perms.includes(permission) || user.email === 'admin@энилекс.рф';

    if (!hasPermission) {
        return (
            <div style={{ padding: '50px', textAlign: 'center' }}>
                <h2>Доступ ограничен</h2>
                <p>У вас нет прав для просмотра этого раздела ({permission}).</p>
            </div>
        );
    }

    return children;
}

function AdminRouter() {
    return (
        <Routes>
            <Route element={<AdminLayout />}>
                <Route index element={<Navigate to="dashboard" replace />} />
                <Route path="dashboard" element={<PermissionRoute permission="dashboard.view"><AdminDashboard /></PermissionRoute>} />
                <Route path="logs" element={<PermissionRoute permission="system.logs"><AdminLogs /></PermissionRoute>} />
                <Route path="users" element={<PermissionRoute permission="users.view"><AdminUsers /></PermissionRoute>} />
                <Route path="public-profiles" element={<PermissionRoute permission="users.view"><AdminPublicProfiles /></PermissionRoute>} />
                <Route path="support" element={<PermissionRoute permission="support.view"><AdminSupport /></PermissionRoute>} />
                <Route path="support/:ticketId" element={<PermissionRoute permission="support.view"><AdminTicketDetail /></PermissionRoute>} />
                <Route path="billing" element={<PermissionRoute permission="billing.view"><AdminBilling /></PermissionRoute>} />
                <Route path="referrals" element={<PermissionRoute permission="referrals.view"><AdminReferrals /></PermissionRoute>} />
                <Route path="jobs" element={<PermissionRoute permission="system.jobs"><AdminJobs /></PermissionRoute>} />
                <Route path="schedules" element={<PermissionRoute permission="system.jobs"><AdminSchedules /></PermissionRoute>} />
                <Route path="api-tokens" element={<PermissionRoute permission="billing.view"><AdminApiTokens /></PermissionRoute>} />
                <Route path="ownership-transfers" element={<PermissionRoute permission="billing.view"><AdminOwnershipTransfers /></PermissionRoute>} />
                <Route path="ai-logs" element={<PermissionRoute permission="system.logs"><AdminAiAgentLogs /></PermissionRoute>} />
                <Route path="ai-chat-shares" element={<PermissionRoute permission="system.logs"><AdminAiChatShares /></PermissionRoute>} />
                <Route path="workspaces" element={<PermissionRoute permission="resources.manage"><AdminWorkspaces /></PermissionRoute>} />
                <Route path="marketplaces" element={<PermissionRoute permission="resources.manage"><AdminMarketplaces /></PermissionRoute>} />
                <Route path="promocodes" element={<PermissionRoute permission="billing.edit"><AdminPromoCodes /></PermissionRoute>} />
                <Route path="marketplace-accounts" element={<PermissionRoute permission="billing.view"><AdminMarketplaceAccounts /></PermissionRoute>} />
                <Route path="agency-requests" element={<PermissionRoute permission="agency.manage"><AdminAgencyRequests /></PermissionRoute>} />
                <Route path="notifications" element={<PermissionRoute permission="notifications.manage"><AdminNotifications /></PermissionRoute>} />
                <Route path="jev" element={<PermissionRoute permission="system.settings"><AdminJev /></PermissionRoute>} />
                <Route path="ai-satisfaction"element={<PermissionRoute permission="system.logs"><AdminAiSatisfaction /></PermissionRoute>} />
                <Route path="blog" element={<PermissionRoute permission="system.settings"><AdminBlogList /></PermissionRoute>} />
                <Route path="blog/new" element={<PermissionRoute permission="system.settings"><AdminBlogEditor /></PermissionRoute>} />
                <Route path="blog/:id/edit" element={<PermissionRoute permission="system.settings"><AdminBlogEditor /></PermissionRoute>} />
                <Route path="news-automation" element={<PermissionRoute permission="system.settings"><AdminNewsAutomation /></PermissionRoute>} />
                <Route path="marketing/utm" element={<PermissionRoute permission="system.settings"><AdminMarketingLinks /></PermissionRoute>} />
                <Route path="marketing/sources" element={<PermissionRoute permission="system.settings"><AdminMarketingSources /></PermissionRoute>} />
                <Route path="marketing/integrations" element={<PermissionRoute permission="system.settings"><AdminMarketingIntegrations /></PermissionRoute>} />
                <Route path="marketing/content-agent" element={<PermissionRoute permission="system.settings"><AdminContentAgent /></PermissionRoute>} />
                <Route path="system-health" element={<PermissionRoute permission="devops.view"><AdminSystemHealth /></PermissionRoute>} />
                <Route path="ops" element={<PermissionRoute permission="devops.view"><AdminOps /></PermissionRoute>} />
                <Route path="settings" element={<PermissionRoute permission="system.settings"><AdminSettings /></PermissionRoute>} />
                <Route path="parser-market" element={<PermissionRoute permission="system.settings"><Navigate to="/admin/parser-hub?tab=executors&executor=parser_market" replace /></PermissionRoute>} />
                <Route path="parser-hub" element={<PermissionRoute permission="system.settings"><AdminParserHub /></PermissionRoute>} />
                <Route path="plan-definitions" element={<PermissionRoute permission="billing.edit"><AdminPlanDefinitions /></PermissionRoute>} />
                <Route path="tool-registry" element={<PermissionRoute permission="billing.edit"><AdminToolRegistry /></PermissionRoute>} />
                <Route path="tool-manual" element={<PermissionRoute permission="billing.edit"><AdminToolManual /></PermissionRoute>} />
                <Route path="notification-catalog" element={<PermissionRoute permission="system.settings"><AdminNotificationCatalog /></PermissionRoute>} />
            </Route>
        </Routes>
    );
}

export default AdminRouter;
